var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditViewBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .cls-2, .cls-3 {\n      fill: none;\n      stroke: black;\n      stroke-miterlimit: 10;\n      stroke-width: 3px;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 17.902984,55.8143 4.41,-9.57 c 0.12,-0.27 0.29,-0.51 0.5,-0.72 l 27.66,-27.29 c 0.57,-0.57 1.5,-0.56 2.07,0 l 4.23,4.23 c 0.57,0.57 0.57,1.49 0,2.07 l -27.29,27.66 c -0.21,0.21 -0.45,0.38 -0.72,0.5 l -9.57,4.41 c -0.83,0.38 -1.68,-0.47 -1.3,-1.3 z m 29.1,-34.14 6.29,6.29 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditViewBlack);
export default __webpack_public_path__ + "static/media/EditView Black.803c2c2ce893b3ac5da25dce26b4b876.svg";
export { ForwardRef as ReactComponent };